export default __webpack_public_path__ + "static/media/resources.cae94536.svg";